import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
const faqs = [{
  q: '¿Esto es Meal Prep?',
  a: 'No en el sentido tradicional. No cocinas platos terminados. Preparas "piezas" flexibles para que cada noche comas lo que te apetece sin esfuerzo.'
}, {
  q: '¿Necesito saber cocinar?',
  a: 'Si sabes calentar una sartén o usar un microondas, sabes usar este sistema.'
}, {
  q: '¿Sirve para toda la familia?',
  a: 'Totalmente. Es la forma más fácil de contentar a todos permitiendo que cada uno ensamble su plato a su gusto.'
}, {
  q: '¿Cuánto tiempo me ahorraré?',
  a: 'Ahorrarás el tiempo y la energía mental que normalmente pierdes dudando qué cocinar cada noche.'
}];
export function FAQSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="py-12 md:py-24 px-4 bg-cream" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-12" data-id="element-3">
          <p className="text-sm font-medium text-sage-dark tracking-widest uppercase mb-4" data-id="element-4">
            Preguntas frecuentes
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-warm-900 leading-tight" data-id="element-5">
            Lo que{' '}
            <span className="italic text-sage-dark font-medium" data-id="element-6">
              te preguntas
            </span>
          </h2>
        </motion.div>

        <div className="space-y-3" data-id="element-7">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-30px'
          }} transition={{
            duration: 0.4,
            delay: i * 0.05
          }} className="bg-white border border-warm-200/60 rounded-2xl overflow-hidden" data-id="element-8">
                <button onClick={() => setOpen(isOpen ? null : i)} className="w-full flex items-center justify-between p-5 md:p-6 text-left" aria-expanded={isOpen} data-id="element-9">
                  <span className="font-heading font-semibold text-lg md:text-xl text-warm-900 pr-4" data-id="element-10">
                    {faq.q}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 45 : 0
              }} transition={{
                duration: 0.25
              }} className="shrink-0 p-1.5 rounded-full bg-sage/10 text-sage-dark" data-id="element-11">
                    <PlusIcon className="w-4 h-4" strokeWidth={2.5} data-id="element-12" />
                  </motion.div>
                </button>
                <AnimatePresence initial={false} data-id="element-13">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-14">
                      <p className="px-5 md:px-6 pb-5 md:pb-6 text-warm-800/80 leading-relaxed" data-id="element-15">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}